<template>
  <div class="box6">
    <div class="titleContent">
      优势一
      <p>内容深</p>
    </div>
    <pageTitle
      title="从零基础到数据挖掘 硬核技能更胜一筹"
      text="课程内容主打数据挖掘，机器学习等热点领域"
      titleColor="#24375C"
      titColor="#86909C"
    />
    <div class="topContent" :class="cur == 0 ? 'left' : 'right'">
      <p @click="changeSwiper(0)">博学谷数据分析课</p>
      <p @click="changeSwiper(1)">一般培训机构</p>
    </div>

    <swiper :options="swiperOption" ref="mySwiper" @slideChange="slideChange()">
      <swiper-slide>
        <div class="content">
          <div class="top">
            <div class="icon"></div>
            <p>博学谷数据分析课</p>
            <div class="skill">重技术</div>
          </div>
          <div class="heng"></div>
          <div class="content1">
            <p>数据分析思维</p>
            <p>数据分析方法论（ABC-XYZ模型、RFM模型等）</p>
            <p>SQL 、Excel、Tableau 等常用工具</p>
            <p>
              常见业务分析案例（常规性指标分析、数据推断、相关性分析、用户生命周期分析、用户留存价值分析）
            </p>
          </div>
          <div class="heng2"></div>
          <div class="content1 content2">
            <p>Python基础</p>
            <p>爬虫</p>
            <p>综合大型项目（金融风控）</p>
            <p>Pandas</p>
            <p>Numpy</p>
            <p>数据决策与应用</p>
            <p>统计学（概率、抽样、假设检验、 因子分析、AB测试等）</p>
            <p>NoSQL（MongoDB、HBase)</p>
            <p>数据可视化（Canvas、Echarts、svg、D3）</p>
            <p>
              机器学习（KNN-K近邻、线性回归、逻辑回归、聚类 算法、Decision
              Tree、集成学习等）
            </p>
          </div>
          <div class="heng3"></div>
          <div class="content1 content3">
            <p>Hadoop</p>
            <p>Hive</p>
            <p>Spark</p>
            <p>综合大型项目（电商推荐系统等）</p>
          </div>
        </div></swiper-slide
      >
      <swiper-slide>
        <div class="content wrap2">
          <div class="top">
            <div class="icon"></div>
            <p>一般培训机构数据分析课</p>
            <div class="exp">偏业务</div>
          </div>

          <div class="content1">
            <div class="box1">
              <p>数据分析思维</p>
              <p>常见数据分析方法论</p>
              <p>SQL、Excel 、Tableau</p>
              <p>常见业务分析案例</p>
            </div>
            <div class="box2">
              <p>Python基础</p>
              <p>爬虫</p>
              <p>数据决策与应用</p>
              <p>Numpy</p>

              <p>Pandas</p>

              <p>常见数据可视化工具</p>
              <p>统计学（概率、抽样、假设检验、因子分析、AB 测试等）</p>
              <p>机器学习（KNN-K近邻、线性回归、逻辑回归、 Decision Tree）</p>
            </div>
          </div>
        </div>
      </swiper-slide>
    </swiper>
    <div class="swiper-pagination-box6"></div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
  },
  data() {
    return {
      cur: 0,
      swiperOption: {
        loop: true, // 循环模式选项
        slidesPerView: "auto",
        spaceBetween: 40,
        slidesPerView: "auto",
        centeredSlides: true,
        pagination: {
          el: ".swiper-pagination-box6",
        },
      },
      list: [
        "阶段二：爬虫与数据可视化",
        "阶段三：机器学习与建模分析",
        "阶段四：大数据分析",
      ],
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  methods: {
    changeSwiper(index) {
      this.$refs.mySwiper.swiper.slideTo(index, 0);
    },
    slideChange() {
      this.cur = this.$refs.mySwiper.$el.swiper.realIndex;
    },
    changeCur(index) {
      this.swiper.slideTo(index, 0);

      this.cur = index;
    },
    close() {
      this.showVideo = false;
    },
  },
};
</script>

<style lang="less" scoped>
.box6 {
  width: 100%;
  background: url("../../../assets/coursePage/dataAnalysis/box6/bgc.png")
    no-repeat;
  background-size: cover;
  padding: 80px 0 0px;
  box-sizing: border-box;
  background-position: top center;
  position: relative;
  .titleContent {
    margin: 0 auto 60px;
    width: 360px;
    height: 80px;
    background: rgba(255, 255, 255, 0.3);
    box-shadow: 0px 4px 20px 0px rgba(202, 211, 235, 0.3),
      inset 2px 2px 2px 0px #ffffff;
    border-radius: 48px;
    backdrop-filter: blur(16px);
    font-size: 32px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #4e5969;
    display: flex;
    padding: 0 8px 0 48px;
    box-sizing: border-box;
    justify-content: space-between;
    align-items: center;
    p {
      width: 176px;
      height: 64px;
      background: linear-gradient(270deg, #8192ff 0%, #a2aeff 100%);
      border-radius: 40px;
      font-size: 32px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 64px;
      text-align: center;
    }
  }
  .swiper-container {
    padding-bottom: 126px;
  }
  .topContent {
    background-size: cover;
    width: 686px;
    height: 98px;
    display: flex;
    margin: 48px auto 0;
    font-size: 28px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    line-height: 56px;
    -webkit-background-clip: text;

    line-height: 88px;
    padding: 0 78px 0 44px;
    box-sizing: border-box;
    justify-content: space-between;
    p:nth-child(2) {
      color: #838c9e;
    }
  }
  .left {
    background: url("../../../assets/coursePage/dataAnalysis/box6/lettop.png")
      no-repeat;
    background-size: cover;
  }
  .right {
    background: url("../../../assets/coursePage/dataAnalysis/box6/righttop.png")
      no-repeat;
    background-size: cover;
    p:nth-child(1) {
      color: #818ca0;
    }
    p:nth-child(2) {
      color: #586196;
    }
  }
  .content {
    height: 1100px;
    background: url("../../../assets/coursePage/dataAnalysis/box6/left.png")
      no-repeat;
    background-size: cover;
    overflow: hidden;
    margin: 24px auto 0;
    box-sizing: border-box;
    background-position: top center;
    width: 686px;
    box-shadow: 0px 20px 60px 0px rgba(17, 12, 162, 0.2),
      inset 2px 4px 4px 0px #ffffff;
    border-radius: 20px;
    padding: 36px 0px 0 40px;
    position: relative;
    .top {
      display: flex;

      box-sizing: border-box;
      align-items: center;
      height: 78px;

      .icon {
        width: 68px;
        height: 68px;
        background: url("../../../assets/coursePage/dataAnalysis/box6/icon.png")
          no-repeat;
        background-size: cover;
      }
      p {
        font-size: 28px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
        line-height: 56px;
        -webkit-background-clip: text;
        margin-left: 28px;
      }
      .skill {
        width: 138px;
        height: 56px;
        background: linear-gradient(180deg, #fcfdff 0%, #e7f1fd 100%);
        box-shadow: 0px 4px 20px 0px rgba(202, 211, 235, 0.3),
          inset -2px -2px 2px 0px rgba(199, 188, 254, 0.66);
        border-radius: 0px 28px 28px 0px;
        font-size: 24px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #5d76ff;
        line-height: 56px;
        margin-left: 142px;
        padding-left: 42px;
        position: relative;
        box-sizing: border-box;
        &::before {
          content: "";
          display: block;
          position: absolute;
          background: url("../../../assets/coursePage/dataAnalysis/box6/skill.png")
            no-repeat;
          width: 82px;
          height: 78px;
          right: 96px;
          background-size: cover;
          top: -10px;
        }
      }
    }
    .heng {
      width: 620px;
      height: 1px;
      background: rgba(255, 255, 255, 0.2);
      opacity: 0;
      margin: 22px 0 36px -8px;
    }
    .heng2 {
      width: 620px;
      height: 1px;
      background: rgba(255, 255, 255, 0.2);
      position: absolute;
      bottom: 628px;
      left: 34px;
      opacity: 0;
    }
    .heng3 {
      width: 620px;
      opacity: 0;
      height: 1px;
      background: rgba(255, 255, 255, 0.2);
      position: absolute;
      bottom: 172px;
      left: 34px;
    }
    .content1 {
      margin-left: -4px;

      p {
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 40px;
        -webkit-background-clip: text;
        padding: 0 0px 0 30px;
        position: relative;
        box-sizing: border-box;
        margin-bottom: 20px;
        &::before {
          content: "";
          display: block;
          left: 0;
          position: absolute;
          top: 13px;
          transform: rotate(45deg);
          width: 16px;
          height: 16px;
          border-radius: 2px;
          box-sizing: border-box;
          border: 4px solid rgba(255, 255, 255, 0.5);
        }
      }
      p:last-child {
        margin-bottom: 0 !important;
      }
    }
    .content2 {
      display: flex;
      flex-wrap: wrap;
      position: absolute;
      bottom: 210px;
      p:nth-child(2) {
        margin-right: 50px;
        margin-left: 20px;
      }
      p:nth-child(5) {
        margin-left: 64px;
        margin-right: 20px;
      }
    }
    .content3 {
      display: flex;
      position: absolute;
      flex-wrap: wrap;

      bottom: 34px;
      p:nth-child(2) {
        margin-left: 96px;
        margin-right: 310px;
      }
      p:nth-child(3) {
        margin-bottom: 0;
      }
      p:nth-child(4) {
        margin-left: 118px;
      }
    }
  }
  .wrap2 {
    height: 1100px;
    background: url("../../../assets/coursePage/dataAnalysis/box6/right.png")
      no-repeat;
    background-size: cover;
    margin: 24px auto 0;
    box-sizing: border-box;
    background-position: top center;
    padding: 28px 0 0 24px;
    box-sizing: border-box;
    width: 686px;

    .top {
      height: 100px;

      .icon {
        width: 100px;
        height: 100px;
      }
      p {
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #4e5969;
        line-height: 47px;
        margin-left: 10px;
      }
    }
    p {
      color: #4e5969 !important;
    }
    .content1 {
      display: flex;
      flex-wrap: wrap;
      margin-left: 14px;
      padding-right: 33px;
      p {
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #4b596b;
        line-height: 40px;
        margin-bottom: 20px;
        &::before {
          border-color: #b7c2ff !important;
        }
      }
      .box1 {
        display: flex;
        flex-wrap: wrap;

        margin-top: 31px;
        height: 290px;

        align-content: center;
        p:nth-child(3),
        p:nth-child(4) {
          margin-bottom: 00px;
        }
        p:nth-child(2) {
          margin-left: 147px;
        }
        p:nth-child(4) {
          margin-left: 40px;
        }
      }
      .box2 {
        display: flex;
        flex-wrap: wrap;

        height: 410px;
        align-content: center;
        margin-top: 46px;
        p:nth-child(2) {
          margin-left: 60px;
        }
        p:nth-child(3) {
          margin-left: 70px;
        }
        p:nth-child(5) {
          margin-left: 106px;
        }
        p:nth-child(6) {
          margin-left: 40px;
        }
      }
    }
    .icon {
      width: 100px;
      height: 100px;
      background: url("../../../assets/coursePage/dataAnalysis/box6/icon2.png")
        no-repeat !important;
      background-size: contain !important;
    }
    .exp {
      color: #4e5969 !important;
      width: 112px;
      height: 46px;
      background: rgba(255, 255, 255, 0.6);
      border-radius: 3px 24px 24px 3px;

      font-size: 25px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #4e5969;
      line-height: 46px;
      padding-left: 12px;
      box-sizing: border-box;
      margin-left: 84px;
    }
    .heng {
      width: 620px;
      height: 1px;
      background: #afb4d5;
      opacity: 0.61;
      margin-left: 10px;
      margin-top: 8px;
      opacity: 0;
      margin-bottom: 106px;
    }
    .heng4 {
      opacity: 0;
      width: 620px;
      height: 1px;
      background: #afb4d5;

      margin-left: -4px;
      margin-top: 68px;
      margin-bottom: 58px;
    }
  }
  .swiper-pagination-box6 {
    display: flex;
    align-items: center;
    position: absolute;
    left: 50%;
    bottom: 88px;
    transform: translate(-50%, 0px);
    height: 6px;
    transform: translate(-50%, 0px);
    background: #c2c9fb;
    border-radius: 3px;
  }

  /deep/ .swiper-pagination-bullet {
    width: 20px;
    height: 6px;
    background: #c2c9fb;
    border-radius: 3px;
  }

  /deep/.swiper-pagination-bullet.swiper-pagination-bullet-active {
    width: 20px;
    height: 6px;
    background: #604bfa;
    border-radius: 3px;
  }
}
</style>
